import React, { useContext } from 'react';
import { LangContext } from '../../../context/DataContext'; 
import Button from '../../../components/common/buttons/Button';

function IncidentesEnrutamiento2024(props) {
    const { myLang } = useContext(LangContext)
    return (   
        <div>    
            <div>
                {myLang === 'es' && <> 
                    <h1>Análisis de incidentes de enrutamiento en la región</h1>
                    <p><strong>Octubre 2023 - Octubre 2024</strong></p>
                    <div className="report-metadata">
                        <p><strong>Autor:</strong> Erika Vega, Chair grupo de trabajo enrutamiento, LACNOG</p>
                        <p><strong>Coordinación y revisión:</strong> Guillermo Cicileo</p>
                        <p><strong>Edición:</strong> Área de Comunicaciones</p>
                        <p><strong>Área:</strong> Área de Tecnología</p>
                        <p><strong>Fecha:</strong> Febrero 2025</p>
                    </div>
                    <Button color="button_blue" to="/reportes/interconexion/lacnic-analisis-incidentes-enrutamiento-lac-es.pdf">Descargar (PDF)</Button>
                </>}
                {myLang === 'en' && <> 
                    <h1>Análisis de incidentes de enrutamiento en la región</h1>
                    <p><strong>Octubre 2023 - Octubre 2024</strong></p>
                    <div className="report-metadata">
                        <p><strong>Autor:</strong> Erika Vega, Chair grupo de trabajo enrutamiento, LACNOG</p>
                        <p><strong>Coordinación y revisión:</strong> Guillermo Cicileo</p>
                        <p><strong>Edición:</strong> Área de Comunicaciones</p>
                        <p><strong>Área:</strong> Área de Tecnología</p>
                        <p><strong>Fecha:</strong> Febrero 2025</p>
                    </div>
                    <Button color="button_blue" to="/reportes/interconexion/lacnic-analisis-incidentes-enrutamiento-lac-es.pdf">Descargar (PDF)</Button>
                </>}
                {myLang === 'pt' && <> 
                    <h1>Análisis de incidentes de enrutamiento en la región</h1>
                    <p><strong>Octubre 2023 - Octubre 2024</strong></p>
                    <div className="report-metadata">
                        <p><strong>Autor:</strong> Erika Vega, Chair grupo de trabajo enrutamiento, LACNOG</p>
                        <p><strong>Coordinación y revisión:</strong> Guillermo Cicileo</p>
                        <p><strong>Edición:</strong> Área de Comunicaciones</p>
                        <p><strong>Área:</strong> Área de Tecnología</p>
                        <p><strong>Fecha:</strong> Febrero 2025</p>
                    </div>
                    <Button color="button_blue" to="/reportes/interconexion/lacnic-analisis-incidentes-enrutamiento-lac-es.pdf">Descargar (PDF)</Button>
                </>}
            </div>
        </div>  
    );
}

export default IncidentesEnrutamiento2024;